import { useEffect } from "react";

const ShapoWidget = () => {
  useEffect(() => {
    // Prevent loading the script multiple times
    if (!document.getElementById("shapo-embed-js")) {
      const script = document.createElement("script");
      script.id = "shapo-embed-js";
      script.src = "https://cdn.shapo.io/js/embed.js";
      script.type = "text/javascript";
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div id="shapo-widget-37852cba414e6f0a2b70"></div>
  );
};

export default ShapoWidget;
